module.exports = __webpack_public_path__ + "img/iso1328-1-2013_figB03_second-order-helix-deviations.d9043e7b.png";